import { FaArrowRight } from "react-icons/fa";
import BrocolyLink from "../../../../utils/BrocolyLink";

const CARDS = [
  {
    title: "Recopilación y Análisis",
    subtitle:
      "Usá herramientas de CRM y plataformas de datos para unificar y analizar la info de tus clientes. Vas a detectar patrones, preferencias… y oportunidades que hoy ni ves.",
  },
  {
    title: "Segmentación de Clientes",
    subtitle:
      "Creá procesos de marketing con chatbots para hacer más eficiente tu operación, ahorrar tiempo, bajar costos y atraer nuevos clientes.",
  },
  {
    title: "Call to Action",
    subtitle:
      "Usá chatbots para guiar a tu audiencia hacia acciones concretas: comprar un producto, conocer precios, acceder a info actualizada del mercado, y más.",
  },
  {
    title: "Feedback Continuo y Ajustes",
    subtitle:
      "Usá chatbots para pedir feedback real y ajustar tus estrategias de venta con lo que tus clientes sienten, no con lo que vos suponés.",
  },
];

export const CardsSection = () => {
  return (
    <>
      <section className="light-section" style={{ marginTop: "4rem" }}>
        <p
          className="section-title"
          style={{ width: "100%", textAlign: "center", marginBottom: "2rem" }}
        >
          <span>
            Pensá como tu cliente: <br />
            el{" "}
            <span style={{ color: "var(--red-highlight)" }}>
              {" "}
              factor clave
            </span>{" "}
            para hacer <br />
            crecer tu negocio
          </span>
        </p>
      </section>
      <section
        className="light-section"
        style={{
          position: "relative",
          paddingBottom: "5rem",
          alignItems: "stretch",
        }}
      >
        <div className="business-cards-layout">
          {CARDS.map((element) => {
            return (
              <div className="business-card" key={element.title}>
                <p>{element.title}</p>
                <p>{element.subtitle}</p>
              </div>
            );
          })}
        </div>
        <div className="brocoly-info">
          <img
            alt="logo-brocoly"
            src={`${process.env.PUBLIC_URL}/assets/imagenes/home/logobrocoly.png`}
            style={{ height: "5rem", marginLeft: "-0.5rem" }}
          />
          <div>
            <p className="brocoly-subtitle">Whatsapp + IA</p>
            <p className="brocoly-description">
              Usá la información para mejorar continuamente la experiencia del
              cliente. <br />
              Los datos te van a permitir detectar oportunidades, valorar a tus
              clientes y tomar decisiones que aumenten su satisfacción y
              compromiso.
            </p>
          </div>
          <span className="horizontal gap-8" style={{ marginTop: "5rem" }}>
            <BrocolyLink>
              <button className="boton-generico boton-verde-amarillo">
                <p>Mirá cómo funciona</p>
                <FaArrowRight />
              </button>
            </BrocolyLink>
            <a
              download
              href="https://binamics.com.ar/brochures/Brocoly_MVP_PricingGeneral.pdf"
              style={{ textDecoration: "none" }}
              target="_blank"
              rel="noreferrer"
            >
              <button
                className="boton-generico boton-blanco"
                style={{ zIndex: 2 }}
              >
                <p>Descargar PDF de brocoly</p>
              </button>
            </a>
          </span>
        </div>
        {/* <img
        alt="whatsapp"
        src={`${process.env.PUBLIC_URL}/assets/imagenes/home/img_avatarbrocoly.png`}
        className="image-brocoly-whatsapp"
      /> */}
      </section>
    </>
  );
};
